module.exports = "<ng-container>\n  <p [innerHTML]=\"sanitize(body)\"></p>\n</ng-container>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/content-safe/content-safe.component.html
// module id = 1004
// module chunks = 0